import avatars from './avatars';
export const opponentNames: any = {
  1: {
    name: 'Shankar',
    avatarId: 15,
    avatar: avatars['0']
  },
  2: {
    name: 'Rahul',
    avatarid: 0,
    avatar: avatars['0']
  },
  3: {
    name: 'Anjali',
    avatarId: 1,
    avatar: avatars['1']
  },
  4: {
    name: 'Dinesh',
    avatarId: 2,
    avatar: avatars['2']
  },
  5: {
    name: 'Hariharan',
    avatarId: 8,
    avatar: avatars['8']
  },
  6: {
    name: 'Ananth',
    avatarId: 3,
    avatar: avatars['3']
  },
  7: {
    name: 'Divya',
    avatarId: 4,
    avatar: avatars['4']
  },
  8: {
    name: 'Ramesh',
    avatarId: 5,
    avatar: avatars['5']
  },
  9: {
    name: 'Ashok',
    avatarId: 11,
    avatar: avatars['11']
  },
  10: {
    name: 'Rohan',
    avatarId: 14,
    avatar: avatars['14']
  }
};
